$(function() {
    var scrollTopElem = $('.go-top');

    scrollTopElem.on('click', function() {
        $('html, body').animate({ scrollTop: 0 }, 200);
    })
    $(window).on('scroll', function() {
        var currentScroll = $(window).scrollTop();
        if (currentScroll > 510) {
            scrollTopElem.removeClass('hidden')
        } else if (currentScroll < 490) {
            scrollTopElem.addClass('hidden')
        }
    })
});